import React from 'react';
import { Stack, Typography, Icon } from '@mui/material';
// import { ReactComponent as CallIcon } from '../../assets/icons/CallIcon.svg';
export default function ContactUs() {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      sx={{ textAlign: 'center', padding: 3 }}
    >
      {/* Heading */}
      <Typography variant="h6" fontWeight="bold">
        Contact us for support
      </Typography>

      {/* Email section */}
      <Stack direction="row" spacing={1} alignItems="center">
        <a href="mailto:helpdesk@benow.in" style={{ textDecoration: 'none', color: 'inherit' }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <img src='/assets/EmailIcon.svg' width="21px" height="auto" alt="Email Icon" />
            <Typography variant="body2">helpdesk@benow.in</Typography>
          </Stack>
        </a>
      </Stack>

      {/* Phone section */}
      <Stack direction="row" spacing={1} alignItems="center">
          <a href="tel:02262634100" style={{ textDecoration: 'none', color: 'inherit' }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <img src='/assets/CallIcon.svg' width="18px" height="auto" alt="Call Icon" />
              <Typography variant="body2">022-6263-4100</Typography>
            </Stack>
        </a>
      </Stack>


      <Stack direction="row" spacing={1} alignItems="center">
      <img src='/assets/ClockIcon.svg' width="18px" height="auto"/>
        <Typography variant="body2">10:00 a.m to 9:00 p.m (All 7 Days)</Typography>
      </Stack>

    </Stack>
  );
}
